import Footer from "components/footer/footer";
import Navbar from "components/navbar";
import PrivacyPolicyBody from "./PrivacyPolicyBody";
import "./privacy.css";

const PrivacyPage = () => (
  <div>
    <Navbar />
    <PrivacyPolicyBody />
    <Footer />
  </div>
);

export default PrivacyPage;
